<template>
  <div
    class="c-progress-bar"
    :class="[{'c-progress-bar--init' : percentage == 0 },
      {'c-progress-bar--completed' : percentage == 100 }]"
  >
    <div
      v-if="!isSingle"
      class="c-progress-bar__buble"
      :style="'left: calc(' + percentage +'% - 20px)'"
    >
      {{percentage}}%
    </div>
    <div class="c-progress-bar__walk">
      <div class="c-progress-bar__progress" :style="'width:' + percentage +'%'"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['percentage', 'isSingle'],
};
</script>
